module.exports = __webpack_public_path__ + "img/标题矩形-默认.5bd88988.png";